import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import appearenceService from "./appearanceService";

const initialState = {
  backgroundStateLoading: false,
  backgroundStateSuccess: false,
  backgroundStateError: false,
  background:"",
  backgroundStateErrorMsg: "",
};

// _______________________createFontSettings response function and services calling
export const createBackgroundSettings = createAsyncThunk(
  "createBackgroundSettings",
  async (data, thunkAPI) => {
    try {
      const response = await appearenceService.createBackgroundSettings(data);
      return response;
    } catch (error) {
      // handle all error like with status code  404 or 500 or 300 , not under 200
      const errorMsg =
        (error.response &&
          error.response.data &&
          error.response.data.errorMsg) ||
        error.errorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(errorMsg);
    }
  }
);

export const backgroundSettingsSlice = createSlice({
  name: 'backgroundSettings',
  initialState,
  reducers: {
    resetBackgroundSettings: (state) => {
      state.backgroundStateLoading = false;
      state.backgroundStateSuccess = false;
      state.backgroundStateError = false;
      state.backgroundStateErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(createBackgroundSettings.pending, (state) => {
        state.backgroundStateLoading = true;
      })
      .addCase(createBackgroundSettings.fulfilled, (state, action) => {
        state.backgroundStateLoading = false;
        state.backgroundStateSuccess = true;
        state.background = action.payload;
      })
      .addCase(createBackgroundSettings.rejected, (state, action) => {
        state.backgroundStateLoading = false;
        state.backgroundStateError = true;
        state.backgroundStateErrorMsg = action.payload; // error from catch will come here via action.payload and update linkErrorMsg
      });
  },
});
export const { resetBackgroundSettings } = backgroundSettingsSlice.actions;
export default backgroundSettingsSlice.reducer;